export const SET_HEADROOM_IS_VISIBLE = '@komigen/mobile-frontend/scroll/SET_HEADROOM_IS_VISIBLE';
export const SET_HEADROOM_NOT_VISIBLE = '@komigen/mobile-frontend/scroll/SET_HEADROOM_NOT_VISIBLE';

const REDUCER_NAME = 'scroll';

const selectHeadroomIsForced = state => state[REDUCER_NAME].navbarIsForced;

const showHeadroom = () => ({
	type: SET_HEADROOM_IS_VISIBLE
});

const hideHeadroom = () => ({
	type: SET_HEADROOM_NOT_VISIBLE
});

function reducer(
	state = {
		navbarIsForced: false
	},
	{ type }
) {
	switch (type) {
		case SET_HEADROOM_IS_VISIBLE:
			return { ...state, navbarIsForced: true };
		case SET_HEADROOM_NOT_VISIBLE:
			return { ...state, navbarIsForced: false };
		default:
			return state;
	}
}

export { showHeadroom, hideHeadroom, selectHeadroomIsForced };
export default reducer;
